// @flow strict
import React from 'react';
import 'smoothscroll-polyfill';
import { Button } from '../Button';

type PropTypes = {
  href: string,
  text: string,
  className: string,
};

const NAV_BREAK_POINT = 650;
const NAV_BAR_HEIGHT_DEFAULT = 83;
const NAV_BAR_HEIGHT_MOBILE = 62;

const AnchorLink = (props: PropTypes) => {
  const calculateOffset = () => {
    const clientWidth = (document && document.body && document.body.clientWidth) || 0;
    if (clientWidth > NAV_BREAK_POINT) return NAV_BAR_HEIGHT_DEFAULT;
    return NAV_BAR_HEIGHT_MOBILE;
  };

  const smoothScroll = () => {
    const id = `#${props.href}`;
    const $anchor = document.querySelector(id);
    const offsetTop = ($anchor ? $anchor.getBoundingClientRect().top : 0) + window.pageYOffset;
    window.scroll({
      top: offsetTop - calculateOffset(),
      behavior: 'smooth',
    });
  };

  return (
    <Button onClick={smoothScroll} variant="SubtleLink" className={props.className}>
      {props.text}
    </Button>
  );
};

export default AnchorLink;
